import { render, staticRenderFns } from "./VeSpacerBlock.vue?vue&type=template&id=933d4c54&scoped=true"
import script from "./VeSpacerBlock.vue?vue&type=script&lang=js"
export * from "./VeSpacerBlock.vue?vue&type=script&lang=js"
import style0 from "./VeSpacerBlock.vue?vue&type=style&index=0&id=933d4c54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933d4c54",
  null
  
)

export default component.exports